import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { LoggingService } from '../../shared/services/core/logging.service';
import { TransactionSuccessQuery } from '../transaction-success/transaction-success.query';

@Injectable({
  providedIn: 'root',
})
/**
 * stop navigation to success pages except when a transaction has been made.
 * optionally include a txRedirect for when navigation fails, else 404:
 * {
 *    path: 'purchaseSuccess'
 *    component: PurchaseSuccessComponent,
 *    canActivate: [ TransactionSuccessGuard ]
 *    data: {
 *            txRedirect: 'purchase'
 *          }
 *  }
 */
export class TransactionSuccessGuard  {

  constructor(
    private loggingService: LoggingService,
    private router: Router,
    private transactionSuccessQuery: TransactionSuccessQuery
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.loggingService.info('transactionSuccessGuard hit');
    const itemExists = !!this.transactionSuccessQuery.getValue().item;
    const queryParams = route.queryParams;
    const purchaseOrderId = queryParams.purchaseOrderId;
    this.loggingService.info(`item exists: ${itemExists}`);
    if (!itemExists && !purchaseOrderId) {
      this.router.navigate([route.data.txRedirect || '404']);
    }
    if (purchaseOrderId) {
      return true;
    }
    return itemExists;
  }
}
